import { render, staticRenderFns } from "./building.vue?vue&type=template&id=1eb7e2d6&scoped=true&"
import script from "./building.vue?vue&type=script&lang=js&"
export * from "./building.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb7e2d6",
  null
  
)

export default component.exports